import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { for: "category" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { for: "amount" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { for: "motif" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*", -1)

import { useValidation } from "vue3-form-validation";
import { activeActivity } from "@/plugins/i18n";
import { numberSeparators, trim } from "@/graphql/utils/utils";
import { useCreateExpense } from "@/graphql/expense/create.expense";
import { useUpdateExpense } from "@/graphql/expense/update.expense";
import { Category, Expense } from "@/graphql/types";
import { useExpensePermissions } from "@/hooks/permissions/useExpensePermissions";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpenseForm',
  props: {
    visible: { type: Boolean },
    categories: {},
    sequenceId: {},
    expense: {}
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { loadCreation, submitCreation } = useCreateExpense(() => {
  resetFields();
  emit("update:visible", false);
});
const { updateLoading, onRowEditSave } = useUpdateExpense(() =>
  emit("update:visible", false)
);
const { canCreate, canUpdate } = useExpensePermissions();
const disabled = computed(() => {
  const enableUpdate =
    Boolean(props.expense) && canUpdate && !updateLoading.value;
  const enableCreate = !props.expense && canCreate && !loadCreation.value;
  return !enableUpdate && !enableCreate && !props.sequenceId;
});
const loading = computed(() => loadCreation.value || updateLoading.value);

const { form, validateFields, resetFields } = useValidation({
  activityId: {
    $value: activeActivity.value.id,
    $rules: [(n: number) => !n && ""],
  },
  sequenceId: {
    $value: props.sequenceId,
  },
  categoryId: {
    $value: props.expense?.category?.id,
    $rules: [(n: number) => !n && ""],
  },
  amount: {
    $value: props.expense?.amount,
    $rules: [(n: number) => !n && ""],
  },
  motif: {
    $value: props.expense?.motif,
    $rules: [(n: string) => !n && ""],
  },
});

function setAmount(value: number) {
  form.amount.$value = value;
  form.amount.$validate();
}

function submit() {
  validateFields().then((input) => {
    //const { motif, ...res } = input;
    trim(input);
    if (!props.expense) submitCreation(input);
    else {
      onRowEditSave({
        id: props.expense.id,
        motif: input.motif,
        amount: input.amount,
        categoryId: input.categoryId,
      });
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    visible: _ctx.visible,
    header: _ctx.$t('expense.addTitle')
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("form", {
        autocomplete: "off",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (submit()), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("product.category")), 1),
          _createVNode(_component_Dropdown, {
            modelValue: _unref(form).categoryId.$value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).categoryId.$value) = $event)),
            options: _ctx.categories,
            filter: true,
            optionLabel: "label",
            class: _normalizeClass({ 'p-invalid': _unref(form).categoryId.$hasError }),
            "filter-fields": ['label'],
            "scroll-height": "150px",
            "empty-filter-message": _ctx.$t('noResult'),
            id: "category",
            "data-key": "id",
            "option-value": "id"
          }, null, 8, ["modelValue", "options", "class", "empty-filter-message"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("expense.amount")) + " ", 1),
            _hoisted_5
          ]),
          _createVNode(_component_InputNumber, {
            "model-value": _unref(form).amount.$value,
            locale: _unref(numberSeparators)[_unref(activeActivity).separator],
            "max-fraction-digits": 20,
            min: 0,
            mode: "decimal",
            id: "amount",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (setAmount(+$event.value))),
            class: _normalizeClass({ 'p-invalid': _unref(form).amount.$hasError })
          }, null, 8, ["model-value", "locale", "class"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("expense.motif")) + " ", 1),
            _hoisted_8
          ]),
          _createVNode(_component_Textarea, {
            modelValue: _unref(form).motif.$value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).motif.$value) = $event)),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(form).motif.$validate())),
            class: _normalizeClass({ 'p-invalid': _unref(form).motif.$hasError }),
            id: "motif",
            style: {"height":"125px"}
          }, null, 8, ["modelValue", "class"])
        ]),
        _createVNode(_component_Button, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          loading: loading.value,
          class: "p-button-outlined",
          type: "submit",
          disabled: disabled.value
        }, null, 8, ["label", "loading", "disabled"])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})